export enum RecruiterActions {
  CUSTOMER_STATUS_FETCHED = 'CUSTOMER_STATUS_FETCHED',
  RECRUITER_SET = 'RECRUITER_SET',
}
